<template>
  <el-form ref="form" :model="form" label-width="80px" :rules="rules">
    <el-form-item label="收货人" prop="contact">
      <el-input v-model="form.contact"></el-input>
    </el-form-item>
    <el-form-item label="手机号" prop="contactPhone">
      <el-input v-model="form.contactPhone"></el-input>
    </el-form-item>
    <el-form-item label="省市区" prop="pca">
      <el-cascader style="width: 100%" :options="areaAddress" :props="props" v-model="form.pca"></el-cascader>
    </el-form-item>
    <el-form-item label="详细地址" prop="address">
      <el-input v-model="form.address"></el-input>
    </el-form-item>
    <el-form-item v-if="!isFromOrder">
      <el-button type="success" @click="onSubmit()">保存</el-button>
      <el-button @click="resetForm()">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import * as apis from "../../fetch/user";
import { address } from "../../fetch/address";

export default {
  name: "InvoiceAddress",
  props: ["from"],
  data() {
    return {
      form: {
        contact: "",
        address: "",
        contactPhone: "",
        pca: ""
      },
      rules: {
        contact: [{ required: true, message: "请输入收货人", trigger: "blur" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        pca: [{ required: true, message: "请选择省市区", trigger: "blur" }],
        contactPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" }
        ]
      },
      props: {
        value: "label",
        children: "children"
      }
    };
  },
  computed: {
    isFromOrder() {
      return this.from === "order";
    },
    areaAddress() {
      return address;
    }
  },
  methods: {
    onSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const params = {
            ...this.form,
            province: this.form.pca[0],
            city: this.form.pca[1],
            area: this.form.pca[2]
          };
          delete params.pca;
          apis.setInvoiceAddress(params).then(res => {
            this.$message({
              message: "操作成功",
              type: "success"
            });
          });
        }
      });
    },
    resetForm() {
      this.$refs["form"].resetFields();
      this.form.pca = [];
    },
    getAddress() {
      apis.getInvoiceAddress().then(item => {
        this.form = { ...item, pca: [item.province, item.city, item.area] };
      });
    }
  },
  mounted() {
    this.getAddress();
  }
};
</script>


<style scoped lang="scss">
</style>